{
  "feeGrid": {
    "defaultFeeGridFor": "Default Fee Grid for",
    "default": {
      "feeGridOrg": "Fee Grid Organization: {{org}}",
      "defaultName": "Fee Grid name: {{name}}",
      "defaultType": "Fee Grid type: ",
      "parentDefault": "Default"
    },
    "table": {
      "name": "Name",
      "type": "Type",
      "default": "Default",
      "state": "State",
      "active": "Active",
      "inactive": "Inactive",
      "flat": "Flat",
      "blendedGrid": "Tiered - Blended",
      "volumeGrid": "Tiered - Volume",
      "organization": "Organization"
    },
    "delete": {
      "confirmationTitle": "Delete Fee Grid",
      "confirmationMessage": "Are you sure you want to delete this Fee Grid?"
    },
    "edit": {
      "title": "Update Fee Grid",
      "updatedToastMessage": "Fee Grid has been updated.",
      "deletedToastMessage": "Fee Grid has been deleted.",
      "name": "Name",
      "type": {
        "label": "Type",
        "tooltip": "Flat - the specified rate will be applied regardless of billable AUM. \nTiered - different billable AUM levels will be charged specific rates.",
        "flat": "Flat",
        "tiered": "Tiered"
      },
      "flatAnnualFeeBpsLabel": "Flat Annual Fee BPS",
      "grid": {
        "to": "to",
        "minAmount": "Minimum",
        "maxAmount": "Maximum",
        "above": "Above",
        "annualFeeBps": "Annual Fee BPS",
        "annualFeeCents": "Annual Fee",
        "type": {
          "label": "Tier Calculation",
          "tooltip": "Blended Fee Grid - different asset levels are charged at their own specific fee rates. E.g. your first $1M is charged and 1.5% and funds from $1-2M are charged 1.25%.\n Volume Fee Grid - fees for all of your book are charged at a certain rate. E.g. less that $1M your fee might be 1.5% but if your portfolio is between $1M-$2M you may pay 1.25% fee for all funds.",
          "blended": "Blended",
          "volume": "Volume"
        }
      },
      "billableAumInclude": {
        "title": "Billable AUM include"
      },
      "chargeForCash": {
        "label": "Cash balance"
      },
      "chargeForCashOnHold": {
        "label": "Cash balance on hold"
      },
      "default": {
        "label": "Default",
        "tooltip": "This fee grid will be automatically applied to a household or client if no fee grid has been set. There can only be one default fee grid.",
        "defaultFlagTooltip": "There can only be one active default fee grid. Remove the default flag from the existing active default fee grid."
      },
      "gridScope": {
        "label": "Group billable AUM with",
        "tooltip": "If a sub account is not part of the selected grouping, billing falls back to the next lower grouping strategy: Account Group → Household → User."
      }
    },
    "new": {
      "title": "New Fee Grid",
      "createdToastMessage": "Fee Grid has been created."
    },
    "errors": {
      "noDefaultFound": "No default fee grid found. Please select one.",
      "multipleDefaultsFound": "Multiple default fee grids found ({{grid_names}}). Please select only one."
    },
    "inherited": "Inherited (Organization Default)",
    "inheritedWithFeeTier": "Inherited ({{applicableFeeTier}})",
    "inheritedWithApplicableBillingSchedule": "Inherited ({{applicableBillingSchedule}})",
    "gridScopeType": {
      "USER": "User",
      "CLIENT_GROUP": "Household",
      "ACCOUNT_GROUP": "Account Group",
      "SUB_ACCOUNT": "Sub-Account"
    }
  },
  "billingCycle": {
    "startDate": "Start date",
    "endDate": "End date",
    "billingDate": "Billing date",
    "calculationDate": "Calculation date",
    "collectedFees": "Collected Fees",
    "projectedFeeAndTax": "Projected Fees & Taxes",
    "totalFeesAndTax": "Total Fees & Tax",
    "organization": "Organization",
    "billableAumLastDay": "Billable AUM Last Day",
    "billableAumWithReductionsApplied": "Reductions Applied",
    "accruedFees": "Accrued Fees",
    "salesTax": "Sales Tax",
    "state": "State",
    "PROCESSED": "Processed",
    "APPROVED": "Approved",
    "AWAITING_REVIEW": "Review",
    "CYCLE_IN_PROGRESS": "Cycle in progress",
    "CYCLE_COMPLETED": "Cycle completed",
    "baseCurrency": "Currency"
  },
  "billingSchedule": {
    "modelName": "billing schedule",
    "defaultBillingScheduleFor": "Default Billing Schedule for",
    "default": {
      "billingScheduleOrg": "Billing Schedule Organization: {{org}}",
      "defaultFrequency": "Repeats: {{frequency}}",
      "parentNextCalculationDate": "Next calculation date: {{nextCalculationDate}}",
      "parentNextBillingDate": "Next billing date: {{nextBillingDate}}",
      "parentDefault": "Default"
    },
    "table": {
      "frequency": "Repeats",
      "default": "Default",
      "state": "State",
      "nextCycle": "Next billing cycle",
      "nextCalculationDate": "Next calculation date",
      "nextBillingDate": "Next billing date",
      "active": "Active",
      "inactive": "Inactive",
      "organization": "Organization"
    },
    "edit": {
      "title": "Update Billing Schedule",
      "updatedToastMessage": "Billing Schedule has been updated.",
      "deletedToastMessage": "Billing Schedule has been deleted.",
      "frequency": "Frequency",
      "frequencyLabel": "Calculate fees every",
      "default": {
        "label": "Default Billing Schedule",
        "tooltip": "This billing schedule will be automatically applied to a household or client if no billing schedule has been set. There can only be one default billing schedule.",
        "defaultFlagTooltip": "There can only be one active default billing schedule. Remove the default flag from the existing active default billing schedule."
      },
      "disclaimerPart1": "Fees are calculated from the 1st to last day of the cycle (month, quarter, etc) and charged to the client in the following billing cycle.",
      "disclaimerPart2": "The fees for this billing cycle from {{startDate}} to {{endDate}} will be calculated on {{nextCalculationDate}} and billed on {{nextBillingDate}}.",
      "calculationDate": "Calculation Date",
      "billingDate": "Billing Date",
      "calcDateMustBePastBillingDate": "Calculation Date must not be past Billing Date"
    },
    "new": {
      "title": "New Billing Schedule",
      "createdToastMessage": "Billing Schedule has been created.",
      "suffix": "day of the month"
    },
    "delete": {
      "confirmationTitle": "Delete Billing Schedule",
      "confirmationMessage": "Are you sure you want to delete this Billing Schedule?"
    },
    "errors": {
      "noDefaultFound": "No default billing schedule found. Please select one.",
      "multipleDefaultsFound": "Multiple default billing schedules found ({{schedule_names}}). Please select only one."
    },
    "frequencies": {
      "MONTHLY": "Monthly",
      "QUARTERLY": "Quarterly",
      "SEMESTRAL": "Semestral",
      "ANNUAL": "Annual"
    }
  },
  "feeReport": {
    "exportTitle": "Billing",
    "exportTypeDaily": "Daily",
    "exportTypeCycle": "Cycle",
    "exportProgressTitle": "Exporting Billing",
    "refreshSubAccountBillingTotals": "Refresh Billing Totals",
    "exportHeaders": {
      "billingCycleId": "Billing Cycle ID",
      "date": "Date",
      "clientId": "Client ID",
      "clientFirstName": "Client First Name",
      "clientLastName": "Client Last Name",
      "clientProvince": "Client Province",
      "entityName": "Client Entity Name",
      "accountId": "Account ID",
      "accountGroupId": "Account Group ID",
      "accountGroupName": "Account Group Name",
      "accountType": "Account Type",
      "accountNumber": "Account Number",
      "subAccountId": "Sub-Account ID",
      "subAccountName": "Sub-Account Name",
      "goalId": "Goal ID",
      "goalName": "Goal Name",
      "portfolio": "Portfolio",
      "aum": "Billable AUM ($)",
      "billableAum": "AUM net of reductions ($)",
      "cash": "Cash ($)",
      "householdAum": "Household AUM ($)",
      "gridScopeTotalMarketValueType": "Tiered Grid Total AUM Level",
      "gridScopeTotalMarketValueCents": "Tiered Grid Total AUM ($)",
      "annualFeeBPS": "Annual fee BPS",
      "dailyFeeBPS": "Daily fee BPS",
      "dailyFee": "Daily fee ($)",
      "organizationId": "Organization ID",
      "organizationName": "Organization Name",
      "feePaymentAccountId": "Fee Payment Account ID",
      "billingCycleState": "Billing Cycle State",
      "billingCycleStartDate": "Billing Cycle Start Date",
      "billingCycleEndDate": "Billing Cycle End Date",
      "billingCycleSalesTax": "Sales Tax ($)",
      "projectedFeeAndTax": "Projected Fees & Taxes",
      "feeGridId": "Fee Grid ID",
      "feeGridName": "Fee Grid Name",
      "feeTierSource": "Fee Grid Source",
      "currency": "Currency",
      "fxRate": "FX Rate",
      "billableAumLastDayDollars": "Billable AUM Last Day ($)",
      "aumNetOfReductionsLastDayDollars": "AUM net of reductions Last Day ($)",
      "billingScheduleFrequency": "Billing Schedule Frequency",
      "cashLastDayDollars": "Cash Last Day ($)",
      "accruedFees": "Accured Fees",
      "totalFeesAndTax": "Total Fees & Tax",
      "salesTax": "Sales Tax ($)",
      "gst": "GST ($)",
      "hst": "HST ($)",
      "pst": "PST ($)",
      "qst": "QST ($)"
    },
    "filters": {
      "billingDateFrom": "Billing Date - From",
      "billingDateTo": "Billing Date - To"
    },
    "table": {
      "accountGroup": "Account Group",
      "client": "Client",
      "organization": "Organization",
      "billingSchedule": "Billing Schedule",
      "billingDate": "Billing Date",
      "feeGrid": "Fee Grid",
      "from": "From",
      "to": "To",
      "billableAumLastDay": "Billable AUM Last Day",
      "billableAumWithReductionsApplied": "Reductions Applied",
      "accuredFees": "Accrued Fees",
      "adjustedAccuredFees": "Adjusted Accrued Fees",
      "salesTax": "Sales Tax",
      "totalFeesAndTax": "Total Fees & Tax",
      "projectedFeeAndTax": "Projected Fees & Taxes",
      "cashAvailable": "Cash Available",
      "feePaymentAccount": "Fee Payment Account",
      "currency": "Currency",
      "refreshSubAccountBillingTotalsInfo": "Billing Fee: {{feeCents}} ({{taxCents}} tax) and Billing Total Daily Fee: {{totalDailyFeeCents}} (excluding tax) are different.",
      "refreshSubAccountBillingTotalsNote": "Note: if the fee override was set, it needs to be unset.",
      "fxRate": "FX Rate"
    },
    "feeTierSource": {
      "SUB_ACCOUNT": "Sub-account",
      "ACCOUNT": "Account",
      "USER": "Client",
      "CLIENT_GROUP": "Household",
      "ORGANIZATION": "Organization",
      "PARENT_ORGANIZATION": "Parent organization"
    },
    "billingScheduleSource": {
      "SUB_ACCOUNT": "Sub-account",
      "ACCOUNT": "Account",
      "USER": "Client",
      "CLIENT_GROUP": "Household",
      "ORGANIZATION": "Organization",
      "PARENT_ORGANIZATION": "Parent organization"
    },
    "feeTierSourceFrom": "From: {{level}}",
    "billingScheduleSourceFrom": "From: {{level}}",
    "approveBillingCycleConfirmationDialog": {
      "approve": "Approve",
      "title": "Approve Billing Cycle",
      "text": "Are you sure you want to approve the Billing Cycle?",
      "toastMessage": "Billing Cycle has been approved"
    },
    "dailyFee": {
      "feeGrid": "Fee Grid: {{feeGrid}}",
      "billingDate": "Billing Date: {{billingDate}}",
      "period": "Fees calculated from {{from}} to {{to}}",
      "date": "Date",
      "billableAum": "Billable AUM",
      "dailyFeeBps": "Daily Fee BPS",
      "dailyFixedFeeCents": "Daily Fixed Fee",
      "totalDailyFeeCents": "Accrued Daily Fee"
    },
    "overrideFees": {
      "title": "Set Fee Override",
      "undo": "Undo Fee Override",
      "adjustedFeeCents": "Adjusted Fees",
      "adjustedSalesTaxCents": "Adjusted Tax",
      "salesTaxConfigurationError": "Couldn't load the sales tax configuration, so the adjusted tax can't be calculated. Try again later.",
      "note": "Note",
      "toastMessage": "Fees have been overriden.",
      "undoMessage": "Fees override has been removed.",
      "copyToClient": "Copy to client's notes"
    }
  }
}
